'use client';

import { motion } from 'framer-motion';
import { Hammer, Construction } from 'lucide-react';
import { Footer } from "@/components/footer";

export default function MakerSpacePage() {
  return (
    <div className="min-h-screen bg-background text-foreground dark:bg-black dark:text-white pt-16 flex flex-col transition-colors duration-300">
      <main className="flex-grow flex items-center justify-center p-6 relative overflow-hidden">
        {/* Background Decorative Elements */}
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-cyan-900/20 rounded-full blur-3xl opacity-50 dark:opacity-30" />
        <div className="absolute bottom-1/4 -right-20 w-96 h-96 bg-blue-900/20 rounded-full blur-3xl opacity-50 dark:opacity-30" />
        
        <div className="relative z-10 max-w-2xl w-full text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="mb-8 flex justify-center"
          >
            <div className="p-6 rounded-full bg-card border border-border backdrop-blur-sm relative group dark:bg-white/5 dark:border-white/10">
              <Hammer className="w-16 h-16 text-cyan-600 dark:text-cyan-400 group-hover:scale-110 transition-transform duration-500" />
              <div className="absolute -top-2 -right-2">
                <motion.div
                  animate={{ rotate: [0, 10, -10, 0] }}
                  transition={{ duration: 4, repeat: Infinity }}
                >
                  <Construction className="w-8 h-8 text-yellow-500" />
                </motion.div>
              </div>
            </div>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl md:text-6xl font-black mb-6 tracking-tight"
          >
            Maker-Space <span className="text-cyan-600 dark:text-cyan-500">—</span> In Progress
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-xl text-muted-foreground mb-12 leading-relaxed dark:text-gray-400"
          >
            Upcoming sections: Community tool access, 3D printing services, and collaborative workshop spaces. 
            <br className="hidden md:block" />
            Where physical craft meets digital innovation.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="inline-flex items-center px-6 py-3 rounded-full bg-card border border-border text-sm font-medium text-muted-foreground dark:bg-white/5 dark:border-white/10 dark:text-gray-300">
              <span className="relative flex h-3 w-3 mr-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-cyan-600 dark:bg-cyan-500"></span>
              </span>
              Under Development Section
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
